export default Object.freeze({
  Taller: 1756,
  Compu: 1757,
  Charla: 1758,
  ServicioEmergencia: 1766,
  PasajeAereo: 1763,
  PasajeMarino: 1764,
  ConsultoriaABA: 1765,
  Admision: 1771,
  DiscusionDePlan: 1770,
  Psicoeducativa: 682,
  PsicoeducativaTwo: 689,
  ServicioEducativo: 1777,
  ABA: 658,
  ProgramaABA: 1787,
  TerapiaEducativa: 1821,
  TerapiaDeHabla: 127,
  TerapiaOcupacional: 128,
  TerapiaPsicologica: 129,
  TerapiaFisica: 130,
  AT: 704,
});
